<style lang="scss">

</style>

<template>
    <div class="countdown-comp text-center">{{timeRemaining}}</div>
</template>

<script>
  import moment from 'moment';

  export default {
    components: {},
    props: {
      date: {
        required: true
      }
    },
    data: function(){
      return{
        clockIntervalId: '',
        timeRemaining: '',
      }
    },
    beforeDestroy() {
      clearInterval(this.clockIntervalId);
    },
    mounted: function () {
      this.fetchTimeRemaining();
      this.pollTimeRemaining();
    },
    methods: {
      pollTimeRemaining() {
        this.clockIntervalId = setInterval(() => {
          this.fetchTimeRemaining();
        }, 1000);
      },
      fetchTimeRemaining() {
        const duration = moment.duration(this.date.diff(moment()));

        if (duration.asSeconds() <= 0) {
          this.timeRemaining = '0:00';
          this.$emit('ended', true);
          return;
        }
        
        if (duration.asHours() >= 1) {
          // For durations over an hour, format as HH:MM:SS
          this.timeRemaining = moment.utc(duration.asMilliseconds()).format('HH:mm:ss');
          return;
        } 

        // For durations under an hour, format as MM:SS
        this.timeRemaining = moment.utc(duration.asMilliseconds()).format('mm:ss');
      },
    }
  }
</script>
